import classnames from 'classnames';
import React, { forwardRef, Ref, ChangeEvent, useId } from 'react';

import '@eika/checkbox-style';
import { ErrorTag } from '@eika/tag';

import { CheckboxProps } from './types';

const Checkbox = forwardRef(
    (
        {
            className,
            value,
            onChange,
            onValueChange,
            label,
            id,
            checked,
            error,
            screenReaderOnlyLabel,
            ...rest
        }: CheckboxProps,
        ref: Ref<HTMLInputElement>,
    ): React.JSX.Element => {
        const generatedId = useId();
        const inputId = id ?? generatedId;
        const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
            if (onChange) onChange(e);
            if (onValueChange) onValueChange(e.target.checked, e.target.value);
        };
        return (
            <React.Fragment key={id}>
                <div className={classnames('sgw-checkbox sgw-checkbox__with_focus', className)}>
                    <div className="sgw-checkbox-wrapper">
                        <input
                            type="checkbox"
                            value={value}
                            checked={checked}
                            onChange={onInputChange}
                            id={inputId}
                            ref={ref}
                            aria-describedby={`${inputId}-error`}
                            {...rest}
                        />
                        <label className={screenReaderOnlyLabel ? 'screen-reader-text' : ''} htmlFor={inputId}>
                            {label}
                        </label>
                    </div>

                    <ErrorTag className="sgw-checkbox__error-label" id={`${inputId}-error`}>
                        {error}
                    </ErrorTag>
                </div>
            </React.Fragment>
        );
    },
);

export default Checkbox;
